export function orderArrayByProperty(array, property) {
  return array.sort((a, b) => a[property] - b[property]);
}

export function orderArrayByStringProperty(array, property) {
  return array.sort((a, b) =>
    a[property].trim().localeCompare(b[property].trim())
  );
}

export function convertObjectToArray(object) {
  let collection = [];
  Object.keys(object).forEach((key) => {
    let objectContent = object[key];
    objectContent.key = key;
    collection.push(objectContent);
  });
  return collection;
}

export function onlyUnique(value, index, array) {
  return array.indexOf(value) === index;
}

export function valuesToArray(array) {
  let collection = [];
  Object.keys(array).forEach((key) => {
    let objectContent = array[key];
    collection.push(objectContent);
  });
  return collection;
}

export function createRange(start, stop) {
  return Array(Math.ceil((stop - start) / 1))
    .fill(start)
    .map((x, y) => x + y * 1);
}
